import { render, staticRenderFns } from "./WorkstationQueues.vue?vue&type=template&id=075f2188&scoped=true"
import script from "./WorkstationQueues.vue?vue&type=script&lang=js"
export * from "./WorkstationQueues.vue?vue&type=script&lang=js"
import style0 from "./WorkstationQueues.vue?vue&type=style&index=0&id=075f2188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075f2188",
  null
  
)

export default component.exports